<template>
  <v-card>
    <v-layout>
      <v-card-title class="headline">
        <strong class="headline deep-purple--text">Editar evento</strong>
      </v-card-title>
    </v-layout>
    <v-divider class="deep-purple" />
    <v-layout row wrap class="mx-4 mt-3">
      <v-flex xs12>
        <h4 class="deep-purple--text">Credor:</h4>
      </v-flex>
      <v-layout row wrap class="mx-4 mt-3">
        <v-flex xs12 sm3 v-for="credor in todos_credores" :key="credor.creditor_id">
          <v-checkbox
            :label="credor.name"
            v-model="credores_seleciondados[credor.creditor_id]"
            color="deep-purple"
          />
        </v-flex>
      </v-layout>
      <v-flex xs12 md12 class="pl-1 mt-2">
        <v-menu offset-y full-width>
          <v-text-field
            slot="activator"
            label="Dia"
            :value="event.event_time | formatDateUTC"
            box
            readonly
          />
          <v-date-picker v-model="event.event_time" locale="br" />
        </v-menu>
      </v-flex>
      <v-flex sm12>
        <v-text-field
          class="mx-1"
          type="text"
          label="Título"
          box
          v-model="event.title"
          hint="máximo: 100 caracteres"
        />
      </v-flex>
      <v-flex sm12>
        <v-textarea
          class="mx-1"
          type="text"
          label="Descrição"
          box
          v-model="event.description"
          hint="máximo: 2000 caracteres"
        />
      </v-flex>
    </v-layout>
    <v-divider class="deep-purple" />
    <v-card-actions class="py-2">
      <v-btn flat color="primary" @click="fechar_modal">Cancelar</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="deep-purple white--text"
        @click="salvar"
        :disabled="esperar || verificar_credor_selecionado"
        >Salvar</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import CreditorService from "@/services/creditor";
export default {
  props: ["item_edicao", "esperar"],
  data() {
    return {
      event: {
        creditors: [],
        event_time: "",
        title: "",
        description: "",
      },
      todos_credores: [],
      credores_seleciondados: [],
    };
  },
  mounted() {
    const self = this;
    CreditorService.list({ active: true })
      .then((res) => {
        self.todos_credores = res.objects;
        res.objects.map((c) => {
          self.credores_seleciondados[c.creditor_id] = false;
        });
      })
      .catch((err) => {
        self.$store.commit("showSnackbar", "Falha ao tentar obter os credores.");
        console.error(err);
      });
  },
  watch: {
    item_edicao: function (novo, antigo) {
      this.event = {
        description: novo.description,
        event_time: novo.event_time.split("T")[0],
        title: novo.title,
        creditors: novo.creditors,
      };
      this.todos_credores.map((c) => {
        this.credores_seleciondados[c.creditor_id] = false;
      });
      novo.creditors.map((c) => {
        this.credores_seleciondados[c.creditor_id] = true;
      });
    },
  },
  methods: {
    fechar_modal() {
      (this.event = {
        event_time: this.item_edicao.event_time.split("T")[0],
        title: this.item_edicao.title,
        description: this.item_edicao.description,
      }),
        this.todos_credores.map((c) => {
          this.credores_seleciondados[c.creditor_id] = false;
        });
      this.item_edicao.creditors.map((c) => {
        this.credores_seleciondados[c.creditor_id] = true;
      });
      this.$emit("fechar");
    },
    salvar() {
      this.event.creditors = this.credores_seleciondados
        .map((c, index) => {
          if (c) {
            return { id: index };
          }
        })
        .filter((c) => {
          return c !== undefined;
        });

      this.$emit("salvar", this.event);
    },
  },
  computed: {
    verificar_credor_selecionado() {
      const temp = this.credores_seleciondados.filter((c) => {
        return c;
      });
      return temp.length === 0;
    },
  },
};
</script>
